var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IsSingleHeader from '../headers/IsSingleHeader';
import IsMultiBet from '../headers/IsMultiBet';
import IsSystemHeader from '../headers/IsSystemHeader';
import * as BetType from '../../../constants/BetType';
import { FormattedMessage, defineMessages } from 'react-intl';
import { operationTypes } from '../../../constants/constants.js';
var messages = defineMessages({
    title: {
        id: 'member-area.operation_type_4',
        defaultMessage: 'Выигрыш RingoGames'
    },
    payment_out: {
        id: 'member-area.history_account_table_payment_out',
        defaultMessage: 'Расход'
    },
    payment_in: {
        id: 'member-area.history_account_table_payment_in',
        defaultMessage: 'Приход'
    },
    odd: {
        id: 'member-area.history_account_table_payment_odd',
        defaultMessage: 'Цена'
    },
    amount: {
        id: 'member-area.history_account_table_payment_amount',
        defaultMessage: 'Кол-во'
    },
    event_results: {
        id: 'member-area.history_account_table_event_results',
        defaultMessage: 'Результаты события'
    },
});
var Stake = function (props) {
    var operationsData = props.operationsData, type = props.type;
    var isSingle = (operationsData.StakeType === BetType.SINGLE);
    var isExpress = (operationsData.StakeType === BetType.EXPRESS);
    var isAntiExpress = (operationsData.StakeType === BetType.ANTIEXPRESS);
    var isSystem = (operationsData.StakeType === BetType.SYSTEM);
    var transactionAmount = operationsData.TransactionAmount;
    var factorValue = operationsData.FactorValue;
    var transactionToShow = type === operationTypes.STAKE_PAYMENT ? transactionAmount : '';
    var amount = type === operationTypes.STAKE ? operationsData.Amount : '';
    return (_jsxs("div", __assign({ className: 'item item--stake-history' }, { children: [isSingle && _jsx(IsSingleHeader, { operationsData: operationsData, operationType: type }), isExpress && _jsx(IsMultiBet, { operationsData: operationsData, type: operationsData.StakeType, operationType: type }), isAntiExpress && _jsx(IsMultiBet, { operationsData: operationsData, type: operationsData.StakeType, operationType: type }), isSystem && _jsx(IsSystemHeader, { operationsData: operationsData, operationType: type }), _jsx("table", { children: _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsxs("td", { children: [_jsx(FormattedMessage, __assign({}, messages.odd)), ": ", _jsx("strong", { children: factorValue })] }), _jsxs("td", { children: [_jsx(FormattedMessage, __assign({}, messages.payment_out)), ": ", _jsx("strong", { children: amount })] })] }), _jsxs("tr", { children: [_jsxs("td", { children: [_jsx(FormattedMessage, __assign({}, messages.amount)), ": ", _jsx("strong", { children: operationsData.Amount })] }), _jsxs("td", { children: [_jsx(FormattedMessage, __assign({}, messages.payment_in)), ": ", _jsx("strong", { children: transactionToShow })] })] })] }) })] })));
};
Stake.propTypes = {
    type: PropTypes.number.isRequired,
    operationsData: PropTypes.object.isRequired
};
export default Stake;



// WEBPACK FOOTER //
// ./src/components/account-history/items/Stake.jsx